import React from 'react'
import Firebase from 'firebase'

import { getDocFromDoc } from './db_util'
import Loading from '../views/misc/Loading'
import Error from '../views/misc/Error'

const withGame = (WrappedComponent) => {

  class componentWithGame extends React.Component {

    constructor(props) {
      super(props)
      this.state = {
        loading: true,
        error: null,
        game: null,
      }
    }

    componentWillMount() {
      this._subscribeToGameChanges()
    }

    componentWillReceiveProps() {
      this._subscribeToGameChanges()
    }

    _subscribeToGameChanges = () => {
      if (this.unsubscribe) {
        this.unsubscribe()
      }
      this.unsubscribeGame = Firebase.firestore().collection('games').doc(this.props.gameId).onSnapshot( doc => {
        let game = getDocFromDoc(doc)
        if (game) {
          this.setState({
            loading: false,
            error: null,
            game: game,
          })
        } else {
          this.setState({
            loading: false,
            error: new Error(`That game doesn't exist anymore`),
            game: null,
          })
        }
      }, error => {
        this.setState({
          loading: false,
          error,
          game: null,
        })
      })
    }

    componentWillUnmount() {
      this.unsubscribeGame()
    }

    render() {

      if (this.state.error) {
        return <Error />
      }

      if (this.state.loading) {
        return <Loading />
      }

      return <WrappedComponent game={this.state.game} {...this.props} />
    }
  }
  componentWithGame.displayName = `withGame(${WrappedComponent.name})`;
  return componentWithGame
}

export default withGame



// WEBPACK FOOTER //
// ./src/data/withGame.jsx